import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, ShieldCheck } from "lucide-react";
import api from "@/lib/api";

export default function VerifyCertificatePage() {
  const { certificateId } = useParams();
  const [certificate, setCertificate] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/certificate/${certificateId}`)
      .then((res) => setCertificate(res.data))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [certificateId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="verify-loading">
        <div className="w-10 h-10 border-2 border-accent border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6" data-testid="verify-certificate-page">
      <div className="glass-panel rounded-2xl p-10 max-w-md w-full text-center">
        <ShieldCheck className="w-10 h-10 text-indigo-400 mx-auto mb-4" />
        {error || !certificate ? (
          <>
            <XCircle className="w-12 h-12 text-red-400 mx-auto mb-3" />
            <h1 className="font-heading text-xl font-semibold text-white">Certificate Not Found</h1>
            <p className="text-sm text-slate-400 mt-2">This certificate ID could not be verified.</p>
          </>
        ) : (
          <>
            <CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto mb-3" />
            <h1 className="font-heading text-xl font-semibold text-white">Certificate Verified</h1>
            <p className="text-sm text-slate-400 mt-3">Awarded to</p>
            <p className="font-heading text-lg font-semibold text-indigo-400">{certificate.user_name}</p>
            <p className="text-sm text-slate-400 mt-2">Score: {certificate.score}%</p>
            <p className="text-xs text-slate-400 mt-4">Certificate ID: {certificate.certificate_id}</p>
            <p className="text-xs text-slate-400">Issued: {new Date(certificate.issued_at).toLocaleDateString()}</p>
            {certificate.integrity_verified && (
              <div className="inline-flex items-center gap-1.5 mt-4 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-3 py-1" data-testid="verify-integrity-badge">
                <ShieldCheck className="w-3.5 h-3.5 text-emerald-400" />
                <span className="text-[11px] font-semibold text-emerald-400">Cryptographic Signature Valid</span>
              </div>
            )}
          </>
        )}
        <Link to="/" className="inline-block mt-6 text-sm text-indigo-400 hover:text-indigo-300">Cloudivo →</Link>
      </div>
    </div>
  );
}
